export const SET_PASSCODE_PARAMS = 'SET_PASSCODE_PARAMS';
export const SET_PASSCODE_DONE = 'SET_PASSCODE_DONE';
export const SET_PASSCODE_ERROR = 'SET_PASSCODE_ERROR';
export const SET_PASSCODE_RESET = 'SET_PASSCODE_RESET';
export const REMOVE_PASSCODE_PARAMS = 'REMOVE_PASSCODE_PARAMS';
export const REMOVE_PASSCODE_DONE = 'REMOVE_PASSCODE_DONE';
export const REMOVE_PASSCODE_ERROR = 'REMOVE_PASSCODE_ERROR';
export const REMOVE_PASSCODE_RESET = 'REMOVE_PASSCODE_RESET';
//# sourceMappingURL=actionTypes.js.map